module.exports = __webpack_public_path__ + "img/9-osim.71b147ce.png";